'use client'
import { memo, type RefObject, type FC } from 'react'
import styled from 'styled-components'
import type { TypeCmsProductDetail } from '@/schema'
import { getP18,  mq, vw } from '@/styles'

type Props = {
  data: {
    description: TypeCmsProductDetail['description']
    name: TypeCmsProductDetail['name']
  }
  ref: RefObject<HTMLElement>
}

const headingId = 'description'
export const SectionDescription: FC<Props> = memo(({ data, ref }) => {
  const { description } = data

  return (
    <Section ref={ref} aria-labelledby={headingId}>
      <h2 id={headingId} className='srt-only'>Description</h2>
      <p>{description}</p>
    </Section>
  )
})

const Section = styled.section`
  grid-column: 1 / span 6;
  grid-row: 2 / span 1;
  max-width: 500px;
  padding-bottom: 40px;

  ${mq.greaterThan('tablet')} {
    grid-column: 1 / span 6;
  }

  h2 {
    ${getP18()}
    font-weight: bold;
    margin-bottom: ${vw(20, 'mobile')};
    text-align: left;

    ${mq.greaterThan('nexus7')} {
      margin-bottom: ${vw(20, 'tablet')};
    }

    ${mq.greaterThan('tablet')} {
      margin-bottom: ${vw(30, 'desktop')};
    }

    ${mq.greaterThan('desktop')} {
      margin-bottom: 30px;
    }
  }



`
